import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@shared/components/ui/shadcn/dialog';
import { useTranslation } from 'react-i18next';

export interface SignatureImageModalProps {
  isOpen: boolean;
  onClose: () => void;
  imageUrl: string;
  'data-testid'?: string;
}

/**
 * Modal para mostrar la imagen de la firma del conductor en grande.
 * Usa Dialog para coexistir correctamente con ModalCenter anidado.
 */
export const SignatureImageModal = ({
  isOpen,
  onClose,
  imageUrl,
  'data-testid': testId = 'signature-image-modal',
}: SignatureImageModalProps) => {
  const { t } = useTranslation('receptionsModule');

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <div data-testid={testId}>
        <DialogContent
          className="p-0 bg-body-bg border-card-border w-[calc(100%-20px)] max-w-5xl"
          data-testid={`${testId}-content`}
          aria-describedby=""
        >
          <DialogHeader className="p-4 pb-2 flex items-start justify-between overflow-hidden">
            <DialogTitle className="text-title text-sm font-medium">{t('modal.create.signature_label')}</DialogTitle>
          </DialogHeader>
          <div className="relative bg-body-bg border-t border-card-border overflow-hidden flex items-center justify-center min-h-[200px] p-4">
            <img
              src={imageUrl}
              alt={t('modal.create.signature_label')}
              className="block object-contain w-auto h-auto max-h-[calc(90vh-120px)]"
              data-testid={`${testId}-image`}
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.style.display = 'none';
                const errorDiv = document.createElement('div');
                errorDiv.className = 'text-text text-center p-4';
                errorDiv.textContent = t('modal.view.signature_load_error');
                target.parentElement?.appendChild(errorDiv);
              }}
            />
          </div>
        </DialogContent>
      </div>
    </Dialog>
  );
};
